import { createSlice } from "@reduxjs/toolkit";

const notificationSliceState =
{
    unreadCount: 0,
    notificationList: []
};

const notificationSlice = createSlice({
    name: "notifications",
    initialState: notificationSliceState,
    reducers: {
        setNotificationList(state, action) {
            state.notificationList = action.payload.sort((a, b) => a.notificationDate < b.notificationDate ? 1 : -1);
            state.unreadCount = action.payload.filter(x => x.isRead === false).length;
        },
        clearUnReadCount(state) {
            state.notificationList = [...state.notificationList.map(item => { return { ...item, isRead: true }; })];
            state.unreadCount = 0;
        }
    },
});

export default notificationSlice;